import { Message } from '@patsnap/tahiti-core/common/message';
import { isPsHttpError } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@telecom/shared/services/i18n';
import type { ErrorHandlerContribution, ErrorHandlerRegistry } from '@patsnap/tahiti-core';

/**
 * 术语表导入超限
 */
const UPLOAD_LIMIT_CODE = 33120012;

/**
 * 导入报错处理(文件)
 */
const UPLOAD_ERROR_FILE_CODE = 33120010;
/**
 * 导入报错处理(格式)
 */
const UPLOAD_ERROR_CODE = 33120011;

@injectable()
export class GlossaryUploadErrorHandler implements ErrorHandlerContribution {
    constructor(
        @inject(Message)
        private readonly _message: Message,
        @inject(I18nService)
        private readonly _i18nService: I18nService,
    ) { }

    registerHandler(handlers: ErrorHandlerRegistry): void {
        this._handleError(handlers);
    }


    private _handleError(handlers: ErrorHandlerRegistry): void {
        handlers.register((error: Error) => {
            if (isPsHttpError(error)) {
                if (error.cause.error_code === UPLOAD_LIMIT_CODE) {
                    const { imported_count } = error.cause.error_params;
                    if (imported_count > 0) {
                        this._message.warning({
                            message: this._i18nService.t('aiTranslation.glossaryImportError', { count: imported_count }),
                        });
                    } else {
                        this._message.error({
                            message: this._i18nService.t('aiTranslation.glossaryImportLimit'),
                        });
                    }
                    return true;
                }
                if (error.cause.error_code === UPLOAD_ERROR_FILE_CODE || error.cause.error_code === UPLOAD_ERROR_CODE) {
                    this._message.error({
                        message: this._i18nService.t('aiTranslation.glossaryImportErrorFile'),
                    });
                    return true;
                }
            }
            return false;
        });
    }
}
